export default function initSlideOut() {
  Alpine.data('slideOut', () => ({
    dialogOpened: false,
    toggleSlideOut() {
      this.dialogOpened = !this.dialogOpened;
      if(this.dialogOpened) {
        document.body.classList.add('dialog-open');
      } else {
        document.body.classList.remove('dialog-open');
      }
    },
    openSlideOut() {
      this.dialogOpened = true;
      document.body.classList.add('dialog-open');
    },
    closeSlideOut() {
      this.dialogOpened = false;
      document.body.classList.remove('dialog-open');
    },
    slideOutClasses(){
      return this.dialogOpened ? 'max-md:translate-x-0': 'max-md:translate-x-full';
    },
    slideOutOverlayClasses() {
      return this.dialogOpened ? 'opacity-100': 'opacity-0';
    },
  }));
}
